import React, { useState, useCallback } from "react";
import FlowieComponent from './alertLabs/FlowieComponent';
import CentricaRegistry from './centrica/CentricaRegistry';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import GasRegistry from "./gas/GasRegistry";
import SteamRegistry from "./steam/SteamRegistry";
import TemperatureRegistry from "./temperature/TemperatureRegistry";
import PHRegistry from "./ph/PHRegistry";
import HubRegistry from "./hubs/HubRegistry";

const SensorContainer = props => {
    const [flowieCount, setFlowieCount] = useState(null);
    const [ctCount, setCTCount] = useState(null);
    const [gasCount, setGasCount] = useState(null);
    const [steamCount, setSteamCount] = useState(null);
    const [temperatureCount, setTemperatureCount] = useState(null);
    const [hubCount, setHubCount] = useState(null);

    const updateSensorCount = useCallback((utility, value) => {
        if(utility === 'water'){
            setFlowieCount(value);
        }else if(utility === 'electricity'){
            setCTCount(value);
        }else if(utility === 'gas'){
            setGasCount(value);
        }else if(utility === 'steam'){
            setSteamCount(value);
        }else if(utility === 'temperature'){
            setTemperatureCount(value);
        }else if(utility === 'hub'){
            setHubCount(value);
        }
    }, []);

    return(
        <div style={{width: '100%', padding:'1%'}}>
            <Accordion defaultExpanded>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                >
                    <h4>{`Water meters${flowieCount ? ` (${flowieCount})` : ''}`}</h4>
                </AccordionSummary>
                <AccordionDetails>
                    <FlowieComponent updateSensorCount={updateSensorCount}/>
                </AccordionDetails>
            </Accordion>

            <Accordion defaultExpanded>
                <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel2a-content"
                id="panel2a-header"
                >
                    <h4>{`Current transducers${ctCount ? ` (${ctCount})` : ''}`}</h4>
                </AccordionSummary>
                <AccordionDetails>
                    <CentricaRegistry updateSensorCount={updateSensorCount}/>
                </AccordionDetails>
            </Accordion>

            <Accordion defaultExpanded>
                <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel3a-content"
                id="panel3a-header"
                >
                    <h4>{`Gas units${gasCount ? ` (${gasCount})` : ''}`}</h4>
                </AccordionSummary>
                <AccordionDetails>
                    <GasRegistry updateSensorCount={updateSensorCount}/>
                </AccordionDetails>
            </Accordion>

            <Accordion defaultExpanded>
                <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="steam-content" id="steam-header">
                    <h4>{`Steam meters${steamCount !== null ? ` (${steamCount})` : ''}`}</h4>
                </AccordionSummary>
                <AccordionDetails><SteamRegistry updateSensorCount={updateSensorCount}/></AccordionDetails>
            </Accordion>

            <Accordion defaultExpanded>
                <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel3a-content"
                id="panel3a-header"
                >
                    <h4>{`Temperature sensors ${temperatureCount ? ` (${temperatureCount})` : ''}`}</h4>
                </AccordionSummary>
                <AccordionDetails>
                    <TemperatureRegistry updateSensorCount={updateSensorCount}/>
                </AccordionDetails>
            </Accordion>

            {/* <Accordion defaultExpanded>
                <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel3a-content"
                id="panel3a-header"
                >
                    <h4>{`pH sensors ${gasCount ? ` (${gasCount})` : ''}`}</h4>
                </AccordionSummary>
                <AccordionDetails>
                    <PHRegistry updateSensorCount={updateSensorCount}/>
                </AccordionDetails>
            </Accordion> */}

            <Accordion defaultExpanded>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel3a-content"
                    id="panel3a-header"
                >
                    <h4>{`Hubs ${hubCount ? ` (${hubCount})` : ''}`}</h4>
                </AccordionSummary>
                <AccordionDetails>
                    <HubRegistry updateSensorCount={updateSensorCount}/>
                </AccordionDetails>
            </Accordion>
        </div>
    );
}

export default SensorContainer;